import * as React from 'react';

import * as Yup from 'yup';
import { Field, FieldProps } from 'formik';

import { TextField } from '@app/components/TextField/TextField';
import { FormTemplate } from '@app/pages/Forms/FormTemplate';
import { simpleBoolSchema, simpleStringSchema } from '@app/services/validationSchemas';
import { TextAreaField } from '@app/components/TextField/TextAreaField';

const subtitle = `Send this special to your friend:
 (Roundtrip Boston) 7 Night Cruise - aboard the Grandeur of the Seas sailing October 27, 2024`;

interface FriendForwardFormValues {
	name: string;
	email: string;
	friendEmail: string;
	note: string;
	isUSEmail: boolean;
	agreeSubmittingTerms: boolean;
}

const initialValues: FriendForwardFormValues = {
	name: '',
	email: '',
	friendEmail: '',
	note: '',
	isUSEmail: false,
	agreeSubmittingTerms: false,
};

const validationSchema = Yup.object().shape({
	name: simpleStringSchema,
	email: Yup.string()
		.email('Invalid email format')
		.notOneOf([Yup.ref('friendEmail')], 'The email address should`t be the same')
		.required('This field is required!'),
	friendEmail: Yup.string()
		.email('Invalid email format')
		.notOneOf([Yup.ref('email')], 'The email address should`t be the same')
		.required('This field is required!'),
	isUSEmail: simpleBoolSchema,
	agreeSubmittingTerms: simpleBoolSchema,
});

const InnerForm = (): JSX.Element => (
	<div className="col-12">
		<div className="layout-container">
			<Field name="name">
				{({ field, form }: FieldProps<string, FriendForwardFormValues>) => (
					<div className="col-12 col-sm-4 form-group">
						<TextField
							value={field.value}
							onChange={(value: string) => form.setFieldValue(field.name, value, false)}
							onBlur={field.onBlur}

							title="Your Name*"

							text={form.touched.name ? form.errors.name : undefined}
							error={Boolean(form.errors.name && form.touched.name)}
						/>
					</div>
				)}
			</Field>
			<Field name="email">
				{({ field, form }: FieldProps<string, FriendForwardFormValues>) => (
					<div className="col-12 col-sm-4 form-group">
						<TextField
							value={field.value}
							onChange={(value: string) => form.setFieldValue(field.name, value, false)}
							onBlur={field.onBlur}

							title="Your Email Address*"
							inputProps={{ type: 'email' }}

							text={form.touched.email ? form.errors.email : undefined}
							error={Boolean(form.errors.email && form.touched.email)}
						/>
					</div>
				)}
			</Field>
			<Field name="friendEmail">
				{({ field, form }: FieldProps<string, FriendForwardFormValues>) => (
					<div className="col-12 col-sm-4 form-group">
						<TextField
							value={field.value}
							onChange={(value: string) => form.setFieldValue(field.name, value, false)}
							onBlur={field.onBlur}

							title="Friend's Email Address*"
							inputProps={{ type: 'email' }}

							text={form.touched.friendEmail ? form.errors.friendEmail : undefined}
							error={Boolean(form.errors.friendEmail && form.touched.friendEmail)}
						/>
					</div>
				)}
			</Field>
			<Field name="note">
				{({ field, form }: FieldProps<number, FriendForwardFormValues>) => (
					<div className="col-12 form-group">
						<TextAreaField
							value={field.value}
							onChange={(value: string) => form.setFieldValue(field.name, value, false)}
							onBlur={field.onBlur}

							title="Your Message"

							text={form.touched.note ? form.errors.note : undefined}
							error={Boolean(form.errors.note && form.touched.note)}
						/>
					</div>
				)}
			</Field>
		</div>
	</div>
);

export const FriendForward = () => (
	<FormTemplate
		title="Forward To A Friend"
		subtitle={subtitle}
		innerForm={<InnerForm />}
		initialValues={initialValues}
		validationSchema={validationSchema}
		extraCheckbox={{
			fieldName: 'isUSEmail',
			label: 'I certify the above email address(es) belongs to someone in the United States',
		}}
		onSubmit={console.log}
	/>
);
